// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O12hJ{gap:24px}.iqsNs{display:flex;flex-direction:column;align-items:flex-start}.Jw_xQ{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `O12hJ`,
	"serviceDescriptionWrapper": `iqsNs`,
	"serviceDescription": `Jw_xQ`
};
export default ___CSS_LOADER_EXPORT___;
